const ReadIndicator = ({ read, readIndicatorClass }) => {
    return (
        <div className={`read-indicator mt-2 ${read ? "" : "unread"} ${readIndicatorClass}`}
        />
    );
};

export default ReadIndicator
